/**
 * PageHeader — shared top bar with title and bottom divider.
 * Matches the style used in ReportViewer and other pages.
 */
import { Box } from '@amzn/awsui-components-react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export default function PageHeader({ title, children }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header__title-area">
        <Box variant="h1" fontSize="heading-l" fontWeight="bold">{title}</Box>
      </div>
      {children && <div className="page-header__actions">{children}</div>}
    </div>
  );
}
